import React,{ useEffect, useState , useRef } from 'react';
import { FiTrash } from "react-icons/fi";
import axios from 'axios';
import useLocalStorageState from 'use-local-storage-state';
import Resizer from "react-image-file-resizer";
import { FaCamera } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
const DeliveryImages = (props) => {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();      
    const [token, setToken] = useLocalStorageState('token', '');
    const [vehiclesimgdata, setVehiclesimgdata] = useState([]);    
    const [deletedeliveryimageid,setDeleteDeliveryimageid]=useState();
    const [vehicleid,setVehicleid]=useState();
    const [error,setError]=useState();
  useEffect(() => {
    imageLoad(props.jobid);
  },[]);
    const imageLoad=async(vehicleId)=>{
        let endpoint = process.env.REACT_APP_PHP_URL+'vehicle-galleries';
        const formData = {vehicle_id:vehicleId,gallery_type:'delivered'}
        const BEARER_TOKEN = token;
        try{
            setLoading(true);
            const response=await axios(endpoint, {
            method: "POST",
            data:formData,
            withCredentials: true,
            headers: {
                'Authorization': `Bearer ${BEARER_TOKEN}`,
                'Content-Type': 'application/json',
            }
            });
                setVehiclesimgdata(response.data.data);
                var modal = document.getElementById("myModalDeliveryDelete"+vehicleId);
                modal.style.display = "none";
                setLoading(false);
            }
            catch(error) {
                setVehiclesimgdata([]);
                var modal = document.getElementById("myModalDeliveryDelete"+vehicleId);
                modal.style.display = "none";
                setLoading(false);
            };
    }   
    const deletedeliveryphoto=(id,vid)=>{
		setDeleteDeliveryimageid(id);
        setVehicleid(vid);
		var modal = document.getElementById("myModalDeliveryDelete"+vid);
		modal.style.display = "block";
	}
    const closeModel=(vid)=>{
        var modal = document.getElementById("myModalDeliveryDelete"+vid);
        modal.style.display = "none";
    }
    const deleteDeliveryImage=async()=>{
        setError('');           
        let endpoint = process.env.REACT_APP_PHP_URL+'vehicle-gallery/'+deletedeliveryimageid;
        const BEARER_TOKEN = token;
        try{
            setLoading(true);
            const response= await axios(endpoint, {
            method: "DELETE",
            withCredentials: true,
            headers: {
                'Authorization': `Bearer ${BEARER_TOKEN}`,
                'Content-Type': 'application/json',
            }
            });            
                imageLoad(vehicleid);
            }
            catch(error){
                setLoading(false);
                setError('Something went wrong!!');   
                navigate('/'); 
            }	 
    } 
    const uploadFile= async (vehicleid)=>{  
        setError('');       
        try {
        const images = Array.from(document.getElementById('file-upload'+vehicleid).files);
        if (!images) {
            setError('');  
        }
        else
        {
        setLoading(true);
        const formData = new FormData();
        for (const image of images) {
            const resizedImage = await resizeFile(image); // assumes this returns a Blob/File
            formData.append('vehicleImg', resizedImage);
        }
        formData.append('vehicle_id', vehicleid);
        formData.append('gallery_type', 'delivered');
        let endpoint = process.env.REACT_APP_PHP_URL+'vehicle-images-upload';
        const BEARER_TOKEN = token;
            axios(endpoint, {
            method: "POST",
            withCredentials: true,
            data:formData,
            headers: {
                'Authorization': `Bearer ${BEARER_TOKEN}`,
                'Content-Type': 'application/json'
            }
            }).then((response ) => {
                imageLoad(vehicleid);
            }) .catch(error => {
                 setError('Something went wrong!!');  
                 setLoading(false);
                 navigate('/');
            });	
         }
        } catch (err) {
            setError('File Is NOT Image!');  
            setLoading(false);
          }		
	}
    const uploadClickedFile= async (vehicleid)=>{  
        setError('');       
        try {
        const file = document.getElementById('file-upload1'+vehicleid).files[0];
        if (!file) {
            setError('');  
        }
        else
        {
        setLoading(true);
        const image = await resizeFile(file);
        const formData = new FormData();
        formData.append('vehicleImg', image);
        formData.append('vehicle_id', vehicleid); 
        formData.append('gallery_type', 'delivered');       
        let endpoint = process.env.REACT_APP_PHP_URL+'vehicle-images-upload';
        const BEARER_TOKEN = token;
            axios(endpoint, {
            method: "POST",
            withCredentials: true,
            data:formData,
            headers: {
                'Authorization': `Bearer ${BEARER_TOKEN}`,
                'Content-Type': 'application/json'
            }
            }).then((response ) => {
                imageLoad(vehicleid);
            }) .catch(error => {
                 setError('Something went wrong!!');  
                 navigate('/');
                 setLoading(false);
            });	
            }
        } catch (err) {
            setError('File Is NOT Image!');  
            setLoading(false);
          }		
	}		
	const resizeFile = (file) =>
		new Promise((resolve) => {
		  Resizer.imageFileResizer(
			file,
			800,
			800,
			"JPEG",
			60,
			0,
			(uri) => {
			  resolve(uri);
			},
			"base64"
		  );
		});
if(loading===true)
{
    return(<><div id={"myModalDeliveryDelete"+props.jobid} className="modal"></div>    
                <center>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner><br></br>
                Loading...
                </center>
            </>);
}
    return(    
    <div key="imageload">
        <div className="alert alert-danger" role="alert">
        A simple danger alert—check it out!
        </div>
        <div id={"myModalDeliveryDelete"+props.jobid} className="modal">
            <div className="modal-content">
                <div className="modal-header">                
                <h5></h5>
                <a onClick={()=>closeModel(props.jobid)}><span className="close" >&times;</span></a>
                </div>
                <div className="modal-body">
                <p style={{ marginTop: '1.5rem', marginBottom: '1.5rem', textAlign: 'center'}}>Are you sure you want to delete this?</p>
                </div>
                <div className="modal-footer">
                <button className="btn btn-primary" onClick={()=>closeModel(props.jobid)} style={{ paddingBottom: '10px', paddingTop: '10px'}}>Cancel</button>
                <button className="loginbtn btn btn-primary" style={{width:"72px"}} onClick={deleteDeliveryImage}>Yes</button>
                </div>
            </div>
        </div>
        {vehiclesimgdata.length === 0 ? (
        <div key="Jobimages0" className="dispImg">
            <table style={{width:'100%'}}>
            <tbody>
                    <tr><td>No images uploaded!!</td></tr>
                </tbody>
            </table>						
        </div>
      ) : (
        vehiclesimgdata.map((item4,index4) => (
            <div key={"Jobimages"+index4} className="dispImg">
            <table style={{width:'100%'}}>
                <tbody>
                    <tr><td style={{width:'30%'}}><img src={item4.file_url} alt="" style={{width:'100px'}} /></td><td style={{ width: props.jobstatus === 'Ready to deliver' && props.jobstatus !== null ? '60%' : '70%' }}><div className="box">{item4.file_name}</div><span className="sizecss">{item4.file_size}</span></td>{props.jobstatus==='Ready to deliver' && props.jobstatus!==null ?<td valign="middle"><a onClick={()=>deletedeliveryphoto(item4.id,props.jobid)}><FiTrash style={{float:'right',color:'red'}}/></a></td>:''}</tr>
                </tbody>
            </table>						
            </div>
        ))
        )}
    <div className="invalid-feedback">{error}</div>
    {props.jobstatus==='Ready to deliver' && props.jobstatus!==null ?
    vehiclesimgdata.length < 6 && (
    <>
    <label htmlFor={"file-upload"+props.jobid} className="loginbtn btn btn-primary center" style={{marginTop:'20px',background:'black'}}>
        Upload photos
    </label>
    <input id={"file-upload"+props.jobid}  accept="image/*" type="file" onChange={()=>uploadFile(props.jobid)} />
    <label htmlFor={"file-upload1"+props.jobid} className="loginbtn btn btn-primary center clickPic" style={{marginTop:'20px',background:'black'}}>
    <FaCamera /> { }Click photo
    </label>
    <input id={"file-upload1"+props.jobid} accept="image/*" type="file" capture="environment" onChange={()=>uploadClickedFile(props.jobid)} />
    </>)
    :''}
    </div>
    )
}
export default DeliveryImages;